import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { EASE } from "@/lib/motion";

export const PersistentCTA = ({ onClick }) => {
  const ref = useRef(null);
  const [d, setD] = useState({ x: 0, y: 0 });
  const [hover, setHover] = useState(false);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > window.innerHeight * 0.75);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    setD({
      x: (e.clientX - (r.left + r.width / 2)) * 0.22,
      y: (e.clientY - (r.top + r.height / 2)) * 0.22,
    });
  };

  return (
    <AnimatePresence>
      {shown && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6, ease: EASE }}
          className="fixed bottom-4 right-4 z-[55] md:bottom-8 md:right-8"
        >
      <motion.button
        ref={ref}
        type="button"
        data-testid="persistent-cta"
        onClick={onClick}
        onMouseMove={onMove}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => {
          setHover(false);
          setD({ x: 0, y: 0 });
        }}
        animate={{ x: d.x, y: d.y }}
        transition={{ type: "spring", stiffness: 180, damping: 16, mass: 0.5 }}
        className="group relative flex items-center gap-3 overflow-hidden border border-[#d4ff00] bg-[#0a0a0a] px-5 py-3.5 md:px-7 md:py-4"
      >
        <span
          className="absolute inset-0 bg-[#d4ff00] transition-transform duration-500 ease-swift"
          style={{ transform: hover ? "translateY(0%)" : "translateY(101%)" }}
        />
        <span className="relative label text-[#d4ff00] transition-colors duration-300 group-hover:text-[#0a0a0a]">
          START A PROJECT
        </span>
        <span className="relative text-[#d4ff00] transition-all duration-300 group-hover:translate-x-1 group-hover:text-[#0a0a0a]">
          →
        </span>
      </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
